var StringUtils = (function () {
    function StringUtils() {
    }
    StringUtils.join = function (strings, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.separatorChar, separatorChar = _c === void 0 ? ':' : _c, _d = _b.escapeChar, escapeChar = _d === void 0 ? '\\' : _d;
        function escapeString(input) {
            return input
                .replace(escapeChar, escapeChar + escapeChar)
                .replace(separatorChar, escapeChar + separatorChar);
        }
        return strings.map(escapeString).join(separatorChar);
    };
    StringUtils.split = function (source, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.separatorChar, separatorChar = _c === void 0 ? ':' : _c, _d = _b.escapeChar, escapeChar = _d === void 0 ? '\\' : _d;
        function unEscapeString(input) {
            return input
                .replace(escapeChar + separatorChar, separatorChar)
                .replace(escapeChar + escapeChar, escapeChar);
        }
        var result = [];
        var segmentStart = 0;
        for (var i = 0; i < source.length; i++) {
            var readEscapeChar = false;
            if (source[i] === escapeChar) {
                readEscapeChar = true;
                i++;
            }
            if (!readEscapeChar && source[i] === separatorChar) {
                result.push(unEscapeString(source.substring(segmentStart, i)));
                segmentStart = i + 1;
            }
            if (i === source.length - 1) {
                result.push(unEscapeString(source.substring(segmentStart)));
            }
        }
        return result;
    };
    return StringUtils;
}());
export { StringUtils };
//# sourceMappingURL=stringUtils.js.map


//////////////////
// WEBPACK FOOTER
// ./~/string-split-join/stringUtils.js
// module id = 3
// module chunks = 0 1